import { useState } from "react";

const useOpenSignatory = () => {
    const [openedFile , setOpenedFile] = useState("")

    const handleOpenSignatories = async(file) => {
        setOpenedFile(file)
    }
    
    const modalBtn = {
        onModalClose: async () => {
            setOpenedFile(false)
        }
    }

    return{
        handleOpenSignatories,
        openedFile,
        modalBtn
    }

}

export default useOpenSignatory; 